import { useEffect } from "react";

// The app shell's routes are outside this router's basename, so a <Redirect> would land on
// /app/logout again. Only a full page load reaches them, and replacing keeps the back
// button from walking into the /app copy of the path.
const ShellRedirect = ({ location }) => {

  useEffect(() => {
    window.location.replace(`${location.pathname}${location.search}`);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;

}

export default ShellRedirect;
